module.exports = __webpack_public_path__ + "img/about-glories3.c9d3e72.png";